export default "__VITE_ASSET__lAsfthJ8__"